import React from 'react';
import { Icon } from './Icon.js';
export const IconTableRows2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m11.5,5.25v-2c0-1.517-1.233-2.75-2.75-2.75H3.25C1.733.5.5,1.733.5,3.25v2h11Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m.5,6.75v2c0,1.517,1.233,2.75,2.75,2.75h5.5c1.517,0,2.75-1.233,2.75-2.75v-2H.5Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconTableRows2Fill12.js.map